import styled from '@emotion/styled'
import Text from '../../../../components/common/Text'
import Image from '../../../../components/common/Image'
import Slider from '../../../../components/common/Slider'
import { BACKGROUND, DARK_GRAY, LIGHT_GRAY, WHITE } from '../../../../constant/colors'
import { mobile, useScreen } from '../../../../utils/responsive-helper'
import { Carousel } from 'antd'
import {
  useFetchShopCategroyList,
  useGetProductCategoryList,
} from '../../../../services/shop/shop-query'
import { useCallback, useEffect, useState } from 'react'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'

const Layout = styled.div``

const Section = styled.div`
  margin: 16px 0;
`

const HeaderStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const CategoryCardStyle = styled.div`
  height: 180px;
  width: calc(20% - 16px);
  flex: 0 1 calc(20% - 16px);
  margin: 8px;
  padding: 8px;
  background-color: ${WHITE};
  border-radius: 4px;
  text-align: center;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);

  ${mobile} {
    height: 130px;
    width: 112px;
    flex: 0 1 112px;
    margin: 6px;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
  }
`

const CategoryImageStyle = styled(Image)`
  margin: auto;
  display: block;
  height: 120px;
  max-width: 100%;
  margin-bottom: 8px;

  ${mobile} {
    height: 80px;
  }
`

const CategoryNameStyle = styled(Text)`
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

const CustomStyleCarousel = styled(Carousel)`
  .slick-prev {
    background: ${WHITE};
    color: ${DARK_GRAY};
    border: 2px solid ${LIGHT_GRAY};
    border-radius: 100%;
    padding: 4px;
    width: 24px;
    height: 24px;
    left: -36px;

    :hover {
      color: ${DARK_GRAY};
    }
  }
  .slick-next {
    background: ${WHITE};
    color: ${DARK_GRAY};
    border: 2px solid ${LIGHT_GRAY};
    border-radius: 100%;
    padding: 4px;
    width: 24px;
    height: 24px;
    right: -36px;

    :hover {
      color: ${DARK_GRAY};
    }
  }
  .slick-dots li button {
    display: none;
  }

  .slick-dots li.slick-active {
    display: none;
  }
`

const CategoryContainerCarousel = styled.div`
  margin: auto;
`

const CategoryCardContainerStyle = styled.div`
  height: 386px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`

const ProductCategoryList = () => {
  const { isMobile } = useScreen()
  const { data: productCategoryData } = useGetProductCategoryList()
  const { data: productCategoryList, fetchNextPage, hasNextPage } = useFetchShopCategroyList()
  const [currentSlide, setCurrentSlide] = useState(0)
  const [productCategorySizeArray, setProductCategorySizeArray] = useState([0])
  const [productCategory, setProductCategory] = useState<any[]>([])

  useEffect(() => {
    if (productCategoryData?.totalPages) {
      let newArray = []
      for (let n = 0; n < productCategoryData.totalPages; n++) {
        newArray.push(n)
      }
      setProductCategorySizeArray(newArray)
    }
  }, [productCategoryData])

  const onFetchShopCategory = useCallback(() => {
    fetchNextPage()
  }, [fetchNextPage])

  const handleAfterChangeCarousel = (current: number) => {
    setCurrentSlide(current)
  }

  useEffect(() => {
    if (hasNextPage) {
      onFetchShopCategory()
    }
    if (productCategoryList) {
      let newProductCategory: any[] = []
      productCategoryList?.pages?.map((data) => {
        data?.content?.map((content) => {
          newProductCategory = [...newProductCategory, content]
        })
      })
      setProductCategory(newProductCategory)
    }
  }, [hasNextPage, onFetchShopCategory, productCategoryList])

  return (
    <Layout>
      {productCategoryData?.content && (
        <Section>
          <HeaderStyled>
            <Text size={isMobile ? 24 : 32} type="SemiBold">
              หมวดหมู่สินค้า
            </Text>
          </HeaderStyled>
          {isMobile ? (
            <Slider backgroundColor={BACKGROUND}>
              {productCategory?.map((category, index) => {
                return (
                  <CategoryCardStyle key={index}>
                    <CategoryImageStyle src={category.imagePath} />
                    <CategoryNameStyle>{category.name}</CategoryNameStyle>
                  </CategoryCardStyle>
                )
              })}
            </Slider>
          ) : (
            <CustomStyleCarousel
              arrows
              prevArrow={<AiOutlineLeft />}
              nextArrow={<AiOutlineRight />}
              afterChange={(current) => handleAfterChangeCarousel(current)}
            >
              {productCategorySizeArray?.map((index) => (
                <CategoryContainerCarousel key={index}>
                  <CategoryCardContainerStyle>
                    {productCategoryList?.pages[currentSlide]?.content.map((category, index) => {
                      return (
                        <CategoryCardStyle key={index}>
                          <CategoryImageStyle src={category.imagePath} />
                          <CategoryNameStyle>{category.name}</CategoryNameStyle>
                        </CategoryCardStyle>
                      )
                    })}
                  </CategoryCardContainerStyle>
                </CategoryContainerCarousel>
              ))}
            </CustomStyleCarousel>
          )}
        </Section>
      )}
    </Layout>
  )
}

export default ProductCategoryList
